/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const boat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#boat_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.378 10.951h7.157c.332 0 .559.359.427.657-.214.46-.443.953-.89 1.44-1.58 1.728-3.42 1.952-5.76 1.952-2.341 0-4.423-.383-6.162-1.952-.527-.476-.853-.89-1.111-1.44a.474.474 0 0 1 .426-.657h5.913Zm0 0V8.223m0 0V1.752c0-.708-.877-1.031-1.313-.456l-4.12 6.227c-.2.3.034.701.387.7h5.046Zm3.464-5.31 2.82 4.383c.192.3-.039.703-.385.704H10V3.16c0-.45.61-.609.842-.247Z"
      />
    </g>
    <defs>
      <clipPath id="boat_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default boat
